export default __webpack_public_path__ + "static/media/docs.f03e9328.svg";